import { useQuery } from '@tanstack/react-query';
import { Endpoint, QueryKey } from '@/constants';
import { getData } from '@/utils/getData';

export const useGetStoredAddresses = (isAuthenticated: boolean) => {
  const { data } = useQuery({
    enabled: isAuthenticated,
    queryFn: getData(Endpoint.StoredDeliveryAddresses),
    queryKey: [QueryKey.StoredDeliveryAddresses],
  });

  return data?.data ?? [];
};
